module.exports = __webpack_public_path__ + "static/media/values_time_icon.cf2345fc.svg";